import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { authService } from "@services/authService";
type IMyRoute = {
  element: ReactElement;
  isPublic: boolean;
};
const MyRoute = ({
  element,
  isPublic
}: IMyRoute) => {
  const isAuthenticated = authService.isAuthenticated();
  return isPublic ? !isAuthenticated ? element : <Navigate to="/inicio" /> : isAuthenticated ? element : <Navigate to="/login" />;
};
export default MyRoute;